import ReportDefaultLoading from './ReportDefaultLoading';

export default ReportDefaultLoading;
